module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAECAYAAAAgaQkXAAAAqUlEQVQ4T+1T2w3CMAy8sxmCzlIWgDWQWAoyHpQ/1AUA2Y7b8IEE//mIbJ8vfpwSjmXeK56F5CAkhAAJt1pj80UITbz6KsYjzBo3LKCWbzEBNplv7jov+W4/6yw9a13vtcyQveqs2XupE3lp8NhpxXyvxKqfmCByqYX78HhS4sjd5XETcghCF+4H4SDA1IX7/8WZcHeO5/mg8ioktv3Fxff08/2rXpU4vQHxUxZVQfJRugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/assessRight.png
// module id = RGIX
// module chunks = 1